import {DefaultModule, registerModule} from "../../builder/DashboardConfigServiceRegistry";

registerModule('ICP4SEE', new class extends DefaultModule {
    overrideUIStrings() {
        return {
          "Asset Management": "SolarSense"
        }
      }
})